<div class="container mainContainer">
  <div class="header margin-bot">
    <div class="title">
      {{ 'onboarding.4.title' | translate }}
    </div>
  </div>
  <div class="row row-gap-3 productsContainer">
    @for (product of products; track product) {
      <div class="productContainer col-12 col-md-6">
        <div class="productCard" (click)="selectProduct(product)" [class.selected]="selectedProduct?.product_id === product.product_id">
          <div class="title">
            {{ product.name }}
          </div>
          <div class="description">
            {{ product.description }}
          </div>
          <div class="perksTitle">
            {{ 'onboarding.4.perks' | translate }}
          </div>
          <div class="perks">
            <div class="perk">
              <i class="bi bi-check-lg"></i>
              <span class="value">{{ product.nb_adult_max }}</span>
              <div>{{ 'onboarding.4.maxAdults' | translate }}</div>
            </div>
            <div class="perk">
              <i class="bi bi-check-lg"></i>
              <span class="value">{{ product.nb_child_max }}</span>
              <div>{{ 'onboarding.4.maxChildren' | translate }}</div>
            </div>
            @for (perk of product.perks; track perk) {
              <div class="perk">
                <i class="bi bi-check-lg"></i>
                <div>{{ perk }}</div>
              </div>
            }
          </div>
          @if (product.reduction_name) {
            <div class="reduction">
              {{ product.reduction_name }}
            </div>
          }
          @if (product.original_price) {
            <div class="originalPrice">
              <span>
                {{ product.original_price | number }}
                <i class="bi bi-currency-euro"></i>
              </span>
            </div>
          }
          <div class="actualPrice">
            {{ product.actual_price | number }}
            <i class="bi bi-currency-euro"></i>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="header">
    <div class="title">{{ 'onboarding.4.optionsTitle' | translate }}</div>
  </div>
  <div class="row row-gap-3 productsContainer">
    @for (option of options; track option) {
      <div class="productContainer col-12 col-md-6">
        <div class="productCard" (click)="toggleOption(option)" [class.selected]="isOptionSelected(option)">
          <div class="title">
            {{ option.name }}
          </div>
          <div class="description">
            {{ option.description }}
          </div>
          <div class="actualPrice">
            {{ option.actual_price | number }}
            <i class="bi bi-currency-euro"></i>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="buttonsRow">
    <div (click)="buy()" class="buyBtn" [class.disabled]="selectedProduct === undefined">
      {{ 'onboarding.4.buyBtn' | translate }}
    </div>
    @if (canSkip) {
      <button type="button" (click)="skip()" class="skipBtn">
        {{ 'onboarding.4.skipBtn' | translate }}
      </button>
    }
  </div>
</div>
